<template>

    <div class="lesson_page" v-if="bigCat5Lesson != null">
        <div class="main_content" ref="mainContent">

            <div id="navigation_title" v-if="!isWeixinBrowser()" class="navigation">
                <div :style="{height:getStateHeight()+'px'}"></div>
                <div class="left" @click="goToBack">
                    <div class="left_back">
                        <img src="@/Images/icon_white_back.png"/>
                    </div>
                </div>
                <div class="clear"></div>
            </div>

            <div class='video_content'>
                <template v-if="!isEmpty(bigCat5Lesson.explanationVideo)">
                    <video-player class="video-player vjs-custom-skin"
                                  ref="videoPlayer"
                                  :playsinline="true"
                                  :options="playerOptions"
                                  @play="onPlayerPlay($event)"
                                  @ended="onPlayerEnded($event)">
                    </video-player>
                </template>
                <template v-else>
                    <div class="course_img">
                        <img class="course_img_bg" :src="getWholeThumbnailCut(bigCat5Lesson.picture, 160, 90)" alt=""/>
                        <div class="course_img_bgblack"></div>
                        <img class="img2" :src="geneNetworkPicture(bigCat5Lesson.picture)" alt=""/>
                    </div>
                </template>
            </div>
            <div class="page-navbar">
                <mt-navbar class="page-part" v-show="false">
                    <mt-tab-item id="1" :style="isSelected()">互动课</mt-tab-item>
                </mt-navbar>
                <div class="sty_tab_container">
                    <mt-tab-container v-model="selected">
                        <mt-tab-container-item id="1">
                            <div class="top_line"></div>
                            <div class="top_space">
                                <div class="lesson">
                                    <div class="basic_info">
                                        <div class="english_title">
                                            <div class="title">{{bigCat5Lesson.name}}</div>
                                        </div>
                                        <div class="des">
                                            <div class="des" v-if="!isEmpty(bigCat5Lesson.description)">
<!--                                                <div class="des_name"></div>-->
                                                <div class="des_text">{{bigCat5Lesson.description}}</div>
                                                <div class="clear"></div>
                                            </div>
                                        </div>
                                        <div class="clear"></div>
                                    </div>

                                    <!-- 详细信息展示 -->
                                    <div class="lesson_detail">
                                        <div class="split_title"></div>

                                        <div class="lesson_action_j">
                                            <!-- 概念词汇, 逐页跟读 -->
                                            <div class="row_entry">
                                                <div class="entry entry_margin" @click="followWordsClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_words.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Words</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="bigCat5Lesson.followReadWordFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>

                                                <div class="entry margin_left30" @click="readFullTextClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_speaking.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Listen and Read</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="bigCat5Lesson.readFullPageFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- 阅读理解, 课外拓展 -->
                                            <div class="row_entry">
                                                <div class="entry entry_margin" @click="readingComprehensionClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_quiz.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Quiz</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="bigCat5Lesson.readingComprehensionFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>

                                                <div v-show="bigCat5Lesson.courseId === 1" class="entry margin_left30" @click="expandClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_famliy_time.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Worksheets</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="bigCat5Lesson.expansionSupplementFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>

                                                <!-- 思维导图 -->
                                                <div v-show="bigCat5Lesson.courseId === 2" class="entry margin_left30" @click="mindMapClick()">
                                                    <div class="back_entry">
                                                        <img class="icon" src="@/Images/icon_game.png" alt="" />
                                                        <div class="entry_title">
                                                            <span>Mind Map</span>
                                                        </div>
                                                    </div>

                                                    <div class="finish_flag">
                                                        <img v-if="bigCat5Lesson.mindmapFinish === 1" src="@/Images/icon_finished.png" alt=""/>
                                                        <img v-else src="@/Images/icon_unfinish.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="bottom_space"></div>
                                    </div>
                                </div>
                            </div>
                        </mt-tab-container-item>
                    </mt-tab-container>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {MessageBox, Toast} from "mint-ui";
    import Vue from "vue";
    import {videoPlayer} from 'vue-video-player'
    import 'vue-video-player/src/custom-theme.css'
    import 'video.js/dist/video-js.css'
    import Utils from '@/pages/Program/util2.js';

    export default {
        components: {
            videoPlayer
        },
        data() {
            return {
                selected: '1',
                lessonId: 0,
                userId: 0,
                bigCat5Lesson: null,
                progress: 0,
                isPlay: false,
                playerOptions: {
                    //播放速度
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    //如果true,浏览器准备好时开始回放。
                    autoplay: false,
                    // 默认情况下将会消除任何音频。
                    muted: false,
                    // 导致视频一结束就重新开始。
                    loop: false,
                    // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    preload: 'auto',
                    language: 'zh-CN',
                    // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    aspectRatio: '16:9',
                    // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    fluid: true,
                    sources: [{
                        //类型
                        type: "video/mp4",
                        //url地址
                        src: ''
                    }],
                    //你的封面地址
                    poster: '',
                    //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    notSupportedMessage: '此视频暂无法播放，请稍后再试',
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        //全屏按钮
                        fullscreenToggle: true
                    }
                },
            }
        },
        methods: {
            goToBack() {
                window.PLessonScrollTop = 0;
                this.goBack(this.$router);
            },
            isSelected() {
                return {
                    color: '#ff5050',
                    'border-bottom': '0 solid #ff5050',
                    cursor: 'pointer'
                };
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            onPlayerPlay: function (e) {
                let that = this;

                if (!that.isWeixinBrowser()) {
                    //此方法不可以在异步方法中执行
                    if (e.requestFullscreen) {
                        e.requestFullscreen();
                    } else if(e.mozRequestFullScreen) {
                        e.mozRequestFullScreen();
                    } else if(e.msRequestFullscreen) {
                        e.msRequestFullscreen();
                    } else if(e.oRequestFullscreen) {
                        e.oRequestFullscreen();
                    } else if(e.webkitRequestFullscreen) {
                        e.webkitRequestFullScreen();
                    }
                }
            },
            onPlayerEnded: function (e) {
                let that = this;

                // 设置视频播放完成
                Utils.$emit('setBigCat5Finished', that.lessonId, 1);

                let url = "bigCat6/updateUserViewCount/" + that.lessonId;
                this.$axios.get(url).then((response) => {
                    if (response.data === 1) {
                        if (e.exitFullscreen){
                            e.exitFullscreen();
                        } else if (e.webkitExitFullscreen) {
                            e.webkitExitFullscreen()
                        }
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            followWordsClick: function () {
                this.$router.push({
                    name: 'BFFollow', query: {lessonId: this.lessonId, courseId:this.bigCat5Lesson.courseId}
                });
            },
            readFullTextClick: function () {
                this.$router.push({
                    name: 'BFPageWord', query: {lessonId: this.lessonId, courseId:this.bigCat5Lesson.courseId}
                });
            },
            readingComprehensionClick: function () {
                this.removeChoicequestionLocalStorage();

                this.$router.push({
                    name: 'BFChoicequestion', query: {lessonId: this.lessonId, courseId:this.bigCat5Lesson.courseId}
                });
            },
            mindMapClick: function () {
                this.$router.push({
                    name: 'BFMindMap2', query: {lessonId: this.lessonId}
                });
            },
            expandClick: function () {
                let that = this;
                Utils.$emit('setBigCat5Finished', that.lessonId, 5);

                this.$router.push({
                    name: 'BFExpansion', query: {lessonId: this.lessonId}
                });
            },
            showStatus: function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatus(0);
            });
        },
        beforeRouteLeave(to, from, next) {
            if (to.name !== "BFAfter") {
                window.BFLessonScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            }

            this.showStatus(1);
            next();
        },
        mounted: function () {
            window.BFLessonScrollTop = 0;
        },
        activated() {
            window.scrollTo(0, window.BFLessonScrollTop);
        },
        beforeCreate() {
            let vlessonId = parseInt(this.$route.query.lessonId);
            let url = "bigCat6/getLessonHomeInfo/" + vlessonId;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.bigCat5Lesson = response.data;
                that.lessonId = vlessonId;
                that.userId = parseInt(that.$store.state.userid.toString());

                if (!that.isEmpty(that.bigCat5Lesson.explanationVideo)) {
                    let vedioUrl = that.$qiNiuDomainBase + that.bigCat5Lesson.explanationVideo;
                    that.playerOptions.poster = vedioUrl + "?vframe/jpg/offset/2";
                    that.playerOptions.sources[0].src = vedioUrl;
                }

                setTimeout(function () {
                    that.hideStatusAndStopAudio();
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>

    img { pointer-events: none; }

    .navigation .left_back {
        width: 34px;
        height: 34px;
        background-color: #0000005a;
        border-radius: 17px;
        margin-left: 16px;
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .navigation .left .left_back img {
        width: 26px;
        height: 26px;
        margin-right: 2px;
    }

    .main_content {
        width: 100%;
        height: 56.25vmin;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 2222;
    }

    .main_content .left {
        position: absolute;
        z-index: 2223;
        float: left;
        width: 50px;
        height: 44px;
        color: white;
        font-size: 25px;
        text-align: center;
        line-height: 50px;
    }

    .video_content {
        display: inline-block;
        width: 100%;
        height: 56.25vmin;
        background: white;
    }

    /*.top_line {*/
    /*    position: fixed;*/
    /*    width: 100%;*/
    /*    height: 3px;*/
    /*    top: calc(56.25vmin - 3px);*/
    /*    background-color: white;*/
    /*}*/
    .top_space {
        position: fixed;
        width: 100%;
        height: calc(100vmax - 56.25vmin);
        top: calc(56.25vmin - 3px);
        right: 0;
        bottom: 0;
        left: 0;
    }

    .lesson_page {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
        text-align: center;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
    }

    .lesson {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 997;
        display: inline-block;
        text-align: -webkit-center;
        overflow-y: scroll;
        overflow-x: hidden;
    }

    .basic_info {
        float: left;
        width: 100%;
        color: #333333;
        background-color: white;
        padding-top: 20px;
        font-size: 15px;
        text-align: left;
    }

    .basic_info .english_title {
        display: flex;
    }
    .basic_info .english_title .title {
        margin-left: 15px;
        margin-right: 105px;
        margin-bottom: 3px;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
        word-wrap: break-word;
        word-break: normal;
    }
    .basic_info .english_title .course_intro {
        position: absolute;
        width: 80px;
        height: 30px;
        right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
        border: 1px solid #e5e5e5;
    }
    .basic_info .english_title .course_intro img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }
    .basic_info .english_title .course_intro span {
        color: #666666;
        font-size: 13px;
    }

    .basic_info .des {
        display: inline-block;
        position: relative;
        margin-top: 5px;
    }

    .basic_info .des .des_name {
        float: left;
        background-color: #ff505a;
        width: 8px;
        height: 8px;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        margin-left: 15px;
        margin-right: 10px;
        margin-top: 3px;
    }

    .basic_info .des_text {
        width: calc(100vmin - 50px);
        color: #666666;
        font-size: 15px;
        margin-left: 15px;
        margin-right: 15px;
        line-height: 22px;
        font-family: Arial;
        word-wrap: break-word;
        word-break: normal;
        white-space: pre-wrap;
    }
    .basic_info .des_text span {
        color: #333333;
    }

    .lesson_detail {
        width: 100%;
        min-height: 100%;
        background-color: white;
        text-align: left;
    }

    .lesson_detail .detail_title {
        width: calc(100% - 30px);
        margin-left: 15px;
        margin-right: 15px;
        padding-top: 20px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        word-wrap: break-word;
        word-break: normal;
    }

    pre {
        white-space: pre-wrap;
        white-space: -moz-pre-wrap;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        word-wrap: break-word;
    }

    .split_title {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 15px;
    }
    .lesson_detail .remark {
        width: 100%;
        display: inline-block;
        margin-top: 20px;
    }

    .lesson_detail .exercise .title, .lesson_detail .remark .title {
        float: left;
        margin-left: 15px;
        font-size: 16px;
        color: #333333;
    }

    .lesson_detail .exercise .unpurchase span {
        color: #ff5050;
        margin-right: 5px;
    }

    .lesson_detail .exercise .unpurchase img {
        height: 18px;
        vertical-align: middle;
    }

    .lesson_detail .lesson_action_j {
        margin-top: 20px;
        margin-bottom: 10px;
    }
    .lesson_detail .lesson_action_j .row_entry {
        width: 100%;
        display: inline-flex;
        margin-bottom: 50px;
    }
    .lesson_detail .lesson_action_j .entry {
        width: 140px;
        height: 155px;
        text-align: center;
        position: relative;
    }
    .lesson_detail .lesson_action_j .entry_margin {
        margin-left: calc((100vmin - 310px)/2.0);
    }
    .lesson_detail .lesson_action_j .margin_left30 {
        margin-left: 30px;
    }
    .lesson_action_j .entry .back_entry {
        width: 140px;
        height: 140px;
        box-shadow: 0 -2px 0 0 #e5e5e5,   /*上边阴影 */
                    -2px 0 0 0 #e5e5e5,   /*左边阴影  */
                    3px 0 0 0 #e5e5e5,    /*右边阴影 */
                    0 3px 0 0 #e5e5e5;    /*下边阴影 */
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        font-size: 0;
    }
    .lesson_detail .lesson_action_j .icon {
        width: 75px;
        margin-top: 10px;
    }
    .lesson_action_j .entry_title {
        height: 40px;
    }
    .lesson_action_j .entry_title span {
        line-height: 40px;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
    }
    .lesson_detail .lesson_action_j .finish_flag {
        position: absolute;
        bottom: 0;
        left: 50%;
        -webkit-transform: translateX(-50%);
        display: flex;
    }
    .lesson_detail .lesson_action_j .finish_flag img {
        width: 30px;
        height: 30px;
    }

    .bottom_space {
        height: 60px;
    }

    .course_img {
        position: relative;
        width: 100%;
        height: 56.25vmin;
        overflow: hidden;
    }

    .course_img .course_img_bg {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        -webkit-filter:blur(20px);
        filter: blur(20px);
        overflow: hidden;
    }
    .course_img_bgblack {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #00000095;
    }
    .course_img .img2 {
        position: absolute;
        width: 100px;
        height: 100px;
        left:50%;
        top:50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }

</style>
